import Vue from 'vue'
import Router from 'vue-router'
import home from './home'
import user from './user'
import login from './login'
import search from './search'
import article from './article'
import personal from './personal'
import followArticle from './followArticle'
import pay from './pay'
// import { MdUtils } from '@/utils'
import { MdUtils } from '@/utils'
import UserTrack from '@/utils/userTrack'

Vue.use(Router)

MdUtils.removeKeepAlive()
MdUtils.setKeepAlive(MdUtils.initKeepAlive())
const router = new Router({
  mode: 'history',
  routes: [...home, ...user, ...login, ...search, ...article, ...personal, ...followArticle, ...pay],
  scrollBehavior(to) {
    new Promise(resolve => {
      setTimeout(() => {
        let fullPath = to.fullPath
        let keepAlive = to.meta.keepAlive
        if (keepAlive && to.meta.more && to.meta.more[fullPath]) {
          let { top, dom } = to.meta.more[fullPath]
          let el = document.querySelector(dom)
          el.scrollTop = top
        }
        resolve()
      }, 0)
    })
  }
})
function addKeep(to, list) {
  // 添加缓存
  let flag = list.includes(to.name)
  if (!flag) {
    to.meta.more = null
    list.push(to.name)
  }
}

function removeKeep(tag, list) {
  if (!tag.name) return
  let i = list.findIndex(item => item === tag.name)
  let flag = MdUtils.initKeepAlive().find(item => item === tag.name)
  if (!flag && i > -1) list.splice(i, 1)
}

function checkParent(to, from) {
  let toLeng = to.matched.length
  let fromLeng = from.matched.length
  let toParent = to.matched[toLeng - 1].parent ? to.matched[toLeng - 1].parent.name : null
  let fromParent = from.matched[fromLeng - 1].parent ? from.matched[fromLeng - 1].parent.name : null
  return toParent && fromParent && toParent !== fromParent
}

router.beforeEach((to, from, next) => {
  if (from.name === 'login' && !MdUtils.getUserInfo('Id')) {
    // 不能用next因为修改from，from 始终为 login，会来回循环
    window.location.href = '/home'
  } 
  let list = MdUtils.getKeepAlive() || MdUtils.initKeepAlive() // 获取已缓存列表('未登录时之缓存首页)
  let fromName = from.name
  let commitRemoveName = null
  if (to.name === from.meta.fromName && !list.includes(to.name)) commitRemoveName = to.name
  addKeep(to, list)
  if (commitRemoveName) removeKeep(to, list)
  if (to.name === from.meta.fromName || !fromName) {
    // 返回删除无需缓存组件 (判断是否为后退操作)
    if (!from.meta.keepAlive || checkParent(to, from)) removeKeep(from, list)
    if (!to.meta.keepAlive) removeKeep(to, list)
  } else if (from.name) {
    let includeKeepAlive = from.meta.includeKeepAlive || []
    let include = includeKeepAlive.includes(to.name)
    if (checkParent(to, from) && !include) {
      MdUtils.removeKeepAlive()
      list = MdUtils.initKeepAlive()
      MdUtils.setKeepAlive(list)
    }
    addKeep(to, list)
    to.meta.fromName = fromName // 记录上一级url
  }
  
  UserTrack.view(to, from)

  if (!from.name || from.name === 'wxLogonRedirectPage' || from.name === 'login' || from.name === 'pay') {
    to.meta.isFirst = true
  }
  MdUtils.setKeepAlive(list)
  next()
})

export default router
